import {Pipe, PipeTransform} from '@angular/core';
import {ActiviteitType} from './activiteit';

@Pipe({
    name: 'zahActiviteitType',
    standalone: false
})
export class ActiviteitTypePipe implements PipeTransform {
  transform(activiteitType: ActiviteitType): string {
    if (activiteitType === ActiviteitType.CLIENT_MELDING) {
      return 'Cliëntmelding';
    } else if (activiteitType === ActiviteitType.SIGNAALKAART) {
      return 'Signaalkaart';
    }
  }
}
